import React from "react";
import accounting from "accounting";
import StringField from "./StringField";

// Disabling this validation as it fires on change and not on blur.
// Net effect is the function fires with every key stroke and prevents
// proper entering of numeric values
//const normalizeFloat = value => accounting.toFixed(value, 2);

const DecimalField = props =>
  <StringField
    type="number"
    step={0.01}
    min={0}
    //    normalize={normalizeFloat}
    {...props}
  />;

export default DecimalField;



// WEBPACK FOOTER //
// ./components/common/form-field/DecimalField.js